;(function ($) {

    $(document).on('ready Grid::inited Photooverlay::ShowItem', function () {

        var $lazyLoad = $('img.i-lazyload');
        var threshold = $(window).height() * 1.5;

        if (!_($lazyLoad).isEmpty()) {

            $lazyLoad.each(function() {
                var $img = $(this);
                if ($img.parents('.grid_masonry, .slideable-block, .photooverlay__comments').length > 0) {
                    $img.removeClass('i-lazyload').attr('src', $img.data('original'));
                }
            });

            $lazyLoad.filter('.i-lazyload').lazyload({
                threshold:  threshold,
                skip_invisible: false
            });

            $(window).on('load', function() {
                $lazyLoad.on('load', function() {
                    $(window).trigger('LazyLoad::load');
                });
            });

        }
    });

})(jQuery);